// Mock data for Discover Business Class website

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "EduTech Solutions",
    role: "Founder & CEO",
    text: "Discover Business Class helped us scale from ₹50L to ₹5Cr in 18 months. Their systems approach transformed our operations completely.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    company: "ConsultCo",
    role: "Managing Director",
    text: "The community is incredible. Being around serious founders who actually execute has been game-changing for my business mindset.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    company: "ServicePro",
    role: "Founder",
    text: "From chaos to clarity in 90 days. Their customer experience framework alone 3x'd our retention rate.",
    rating: 5
  }
];

export const caseStudies = [
  {
    id: 1,
    client: "Education Platform",
    challenge: "Unstructured operations, 60% customer churn",
    solution: "Implemented systematic onboarding and success protocols",
    result: "Churn reduced to 15%, revenue up 250%",
    timeline: "6 months"
  },
  {
    id: 2,
    client: "B2B Services Company",
    challenge: "Founder stuck in daily operations, no scalability",
    solution: "Built team systems and delegation frameworks",
    result: "Founder time freed by 70%, team productivity up 3x",
    timeline: "4 months"
  },
  {
    id: 3,
    client: "SaaS Startup",
    challenge: "Inconsistent sales process, unpredictable revenue",
    solution: "Designed and implemented sales system and playbook",
    result: "30% increase in close rate, predictable monthly growth",
    timeline: "3 months"
  }
];

export const consultingServices = [
  {
    id: 1,
    title: "Operations & Process Optimization",
    description: "Transform chaos into systematic excellence. Build processes that scale without you.",
    outcomes: [
      "Streamlined workflows that reduce operational overhead by 40%+",
      "Documentation systems that enable team independence",
      "Quality control mechanisms that maintain standards"
    ],
    benefits: "Stop being the bottleneck. Build a business that runs smoothly."
  },
  {
    id: 2,
    title: "Sales & Growth Systems",
    description: "Predictable revenue through systematic sales processes and growth frameworks.",
    outcomes: [
      "Sales playbooks that consistently close deals",
      "Lead generation systems that fill your pipeline",
      "Metrics and dashboards for visibility and control"
    ],
    benefits: "Move from hoping for sales to engineering growth."
  },
  {
    id: 3,
    title: "Customer Experience Design",
    description: "Create experiences that turn customers into advocates and drive retention.",
    outcomes: [
      "Customer journey mapping and optimization",
      "Onboarding systems that ensure success",
      "Feedback loops that drive continuous improvement"
    ],
    benefits: "Build loyalty that compounds revenue over time."
  },
  {
    id: 4,
    title: "Team Training & Development",
    description: "Elevate your team's capability to operate at business class standards.",
    outcomes: [
      "Leadership development for key team members",
      "Process training and standard operating procedures",
      "Performance frameworks that drive accountability"
    ],
    benefits: "Build a team that executes your vision independently."
  }
];

export const communityTiers = [
  {
    id: 1,
    name: "Free",
    price: 0,
    currency: "INR",
    description: "Get started with the fundamentals",
    features: [
      "Access to community resources",
      "Monthly newsletter with insights",
      "Occasional webinars and events"
    ],
    cta: "Join Free",
    popular: false
  },
  {
    id: 2,
    name: "Pro",
    price: 9999,
    currency: "INR",
    billing: "per month",
    description: "Serious growth for serious founders",
    features: [
      "Everything in Free",
      "Weekly group coaching calls",
      "Access to frameworks and templates",
      "Peer mastermind groups",
      "Priority community support",
      "Quarterly strategy sessions"
    ],
    cta: "Upgrade to Pro",
    popular: true,
    stripePriceId: "price_pro_monthly" // This would be replaced with actual Stripe price ID
  },
  {
    id: 3,
    name: "Inner Circle",
    price: 49999,
    currency: "INR",
    billing: "per month",
    description: "Elite network for scaling founders",
    features: [
      "Everything in Pro",
      "1-on-1 monthly strategy calls",
      "Direct access to founders network",
      "Exclusive in-person events",
      "Custom growth playbooks",
      "Priority consulting access",
      "VIP introductions and partnerships"
    ],
    cta: "Apply for Inner Circle",
    popular: false,
    stripePriceId: "price_inner_circle_monthly" // This would be replaced with actual Stripe price ID
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Diagnose",
    description: "Deep dive into your business to identify gaps, bottlenecks, and opportunities."
  },
  {
    step: 2,
    title: "Design",
    description: "Create custom systems and frameworks tailored to your business model and goals."
  },
  {
    step: 3,
    title: "Implement",
    description: "Work hands-on with your team to deploy systems and ensure adoption."
  },
  {
    step: 4,
    title: "Scale",
    description: "Optimize and refine as you grow, ensuring systems evolve with your business."
  }
];

export const aboutSections = {
  belief: {
    title: "Our Belief",
    content: "Most businesses operate in 'economy mode'—unstructured, reactive, and inconsistent. They survive day-to-day but never achieve the clarity and control needed for real scale. We believe business class is not about luxury—it's a standard. It's about structured systems, premium customer experience, and predictable growth."
  },
  mission: {
    title: "Our Mission",
    content: "To help businesses upgrade from chaos to clarity, from average to exceptional. We work with ambitious founders who refuse to settle for mediocrity."
  },
  whatWeDo: {
    title: "What We Do",
    points: [
      "Build systems that scale without founder dependency",
      "Improve customer experience to drive retention and referrals",
      "Help founders think and operate at a higher strategic level"
    ]
  },
  whyWeExist: {
    title: "Why We Exist",
    problems: [
      "Founders stuck in daily operations with no time for strategy",
      "Lack of systems leading to inconsistent results",
      "No clarity on what to do next to grow",
      "Teams that can't execute without constant supervision"
    ],
    solution: "We bridge the gap between where you are and where you want to be."
  }
};
